module.exports = __webpack_public_path__ + "static/img/img_modify.09386f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/regionTutorialIos/img_modify.png
// module id = 1108
// module chunks = 1